import React, { useRef, useState } from 'react';
import { useTournament } from '../hooks/useTournament';

const TournamentTransfer = () => {
  const { exportTournament, importTournament } = useTournament();
  const fileInputRef = useRef(null);
  const [status, setStatus] = useState(null); // { type: 'success'|'error', message }

  const handleExport = () => {
    try {
      exportTournament();
      setStatus({ type: 'success', message: 'Turnier exportiert.' });
    } catch (e) {
      setStatus({ type: 'error', message: 'Export fehlgeschlagen.' });
    }
  };

  const handleImportClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setStatus(null);
    try {
      const ok = await importTournament(file);
      if (ok) {
        setStatus({ type: 'success', message: 'Turnier importiert.' });
      } else {
        setStatus({ type: 'error', message: 'Import abgebrochen.' });
      }
    } catch (err) {
      setStatus({ type: 'error', message: 'Import fehlgeschlagen: ' + err.message });
    } finally {
      e.target.value = '';
    }
  };

  return (
    <div className="section" style={{ marginTop: '16px' }}>
      <div className="section-header">
        <h2>Turnier Transfer</h2>
        <span style={{ fontSize: '0.85rem', color: '#555' }}>Zwischen Geräten wechseln</span>
      </div>
      <p className="info-text" style={{ marginTop: 0 }}>
        Exportiert / importiert den kompletten Turnierstand (Spieler, Einstellungen, Paarungen, Ergebnisse).
      </p>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <button type="button" onClick={handleExport}>Export (JSON)</button>
        <button type="button" onClick={handleImportClick}>Import (JSON)</button>
        <input
          ref={fileInputRef}
          type="file"
          accept="application/json,.json"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>
      {status && (
        <div style={{
          marginTop: '8px',
          padding: '6px 10px',
          borderRadius: '4px',
          fontSize: '0.85rem',
          background: status.type === 'success' ? '#e8f5e9' : '#ffebee',
          color: status.type === 'success' ? '#2e7d32' : '#c62828'
        }}>
          {status.message}
        </div>
      )}
    </div>
  );
};

export default TournamentTransfer;
